import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

// two single-width buttons' worth, plus the one inter-button gap (left+right margins) that
// would otherwise separate them - kept in sync with singleButton's own width below so '='
// doesn't quietly end up too narrow again if that width ever changes
const SINGLE_BUTTON_WIDTH = 40;

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    height: "32px"
  },
  // shared by every single-cell button (digits, operators, scientific tokens) so the grid
  // lines up in even columns rather than narrower/wider buttons per type
  singleButton: {
    minWidth: SINGLE_BUTTON_WIDTH
  },
  doubleButton: {
    minWidth: (SINGLE_BUTTON_WIDTH * 2) + theme.spacing.unit*2
  },
  fillButton: {
    flexGrow: 1
  },
  smallFont: {
    fontSize: '0.7rem'
  },
  plusMinus: {
    fontFamily: 'Courier New, Courier, monospace'
  },
  squareRoot: {
    fontFamily: 'Courier New, Courier, monospace',
  }
});

// values whose label is longer than a single digit and need the smaller font in smallFont
const SCIENTIFIC_BUTTON_VALUES = ['sin', 'cos', 'tan', 'log', 'ln', 'sqrt', '^', 'sq', 'inv', 'pi', 'e', 'paren'];

// nicer glyphs for scientific tokens whose raw button value (used for click handling and
// insertion into the expression) isn't what should be shown on the button itself
const SCIENTIFIC_DISPLAY = {
  sqrt: '√',
  '^': 'x^y',
  sq: 'x²',
  pi: 'π',
  inv: '1/x',
  paren: '( )'
};

const CalculatorButton = ({ value, onSelect, classes, fill }) => {
  if (value === "") {
      const styles = [classes.button, classes.singleButton];
      return <div className={styles.join(" ")} />;
  }

  let display = value;
  const styles = [classes.button];
  styles.push(value === '=' ? classes.doubleButton : classes.singleButton);
  if (fill) {
    styles.push(classes.fillButton);
  }
  if (value === '@') {
    styles.push(classes.plusMinus);
    display = '\xB1';
  }
  if (value === '<') {
    styles.push(classes.plusMinus);
    display = '←';
  }
  if (value === '/') {
    styles.push(classes.plusMinus);
    display = '÷';
  }
  if (value === '*') {
    styles.push(classes.plusMinus);
    // display = 'x';
    display = '×';
  }
  if (value === '}') {
    styles.push(classes.squareRoot);
    display = '√';
  }
  if (SCIENTIFIC_BUTTON_VALUES.includes(value)) {
    styles.push(classes.smallFont);
    display = SCIENTIFIC_DISPLAY[value] || value;
  }

  return (
    <Button
      className={styles.join(' ')}
      variant="contained"
      color="primary"
      size="small"
      onClick={() => {
        if (value) onSelect(value);
      }}
    >
      {display}
    </Button>
  );
};

export default withStyles(styles)(CalculatorButton);
